import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const NOT_FOUND_TITLE = "Page introuvable — Données & Droit";
const NOT_FOUND_DESCRIPTION =
    "Cette page n'existe pas ou n'est plus disponible sur donnees-et-droit.fr.";

export function NotFoundPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main data-testid="not-found-page">
            <SEO
                path="/404"
                title={NOT_FOUND_TITLE}
                description={NOT_FOUND_DESCRIPTION}
                robots="noindex, follow"
            />
            <Header />
            <section
                className="border-b border-slate-200 bg-white"
                data-testid="not-found-section"
            >
                <div className="mx-auto max-w-3xl px-6 md:px-12 lg:px-16 pt-24 md:pt-32 pb-20 md:pb-28">
                    <p className="text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                        Erreur 404
                    </p>
                    <h1
                        className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                        data-testid="not-found-title"
                    >
                        Cette page n'existe pas.
                    </h1>
                    <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed max-w-2xl">
                        L'adresse demandée ne correspond à aucune page du
                        site donnees-et-droit.fr. Le lien est peut-être
                        obsolète ou comporte une erreur de saisie.
                    </p>
                    <div className="mt-10">
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 text-sm font-medium text-[#0B132B] border-b border-[#0B132B] pb-0.5 hover:gap-3 transition-all"
                            data-testid="not-found-back-home"
                        >
                            ← Retour à l'accueil
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    );
}
